<script lang="ts">
  import MiniStoriesContentCard from "@shared/svelte/Components/MiniStories/MiniStoriesContentCard.svelte";
  import Skeleton from "svelte-skeleton/Skeleton.svelte";
  import TrackingContext from "@shared/svelte/Components/Tracking/TrackingContext.svelte";
  import { HttpPromise } from "@shared/svelte/Modules/ApiService";
  import { MiniStoriesContainerEntity } from "@shared/services/event_tracking/entities";

  import type { MiniStory } from "@shared/types/MiniStory";

  export let header: string = "";
  export let name: string = "";
  export let mobileMode = null;
  mobileMode;
  export let type: string | null = null;
  type;

  const trackingParams: MiniStoriesContainerEntity = new MiniStoriesContainerEntity({
    name,
  });

  let loaded: boolean = false;
  let stories: MiniStory[];
  const options = {
    method: "GET",
    url: "/api/retailer/mini_story_placements/mini_story_placements",
  };
  HttpPromise(options).then(res => {
    loaded = true;
    stories = res;
  });
</script>

<div data-testid="featured-mini-stories-container">
  <TrackingContext entities={trackingParams}>
    <section class="fizz-surface-blue">
      <div class="fizz-container fizz-inset-square-32">
        <h2 class="fizz-heading-3 fizz-text-center fizz-stack-24">{header}</h2>

        <div class="fizz-flex-row-responsive fizz-align-content-stretch">
          {#if !loaded}
            {#each Array(3) as _}
              <Skeleton animate={true} height={412} width={375} />
            {/each}
          {:else if stories && stories.length}
            {#each stories as miniStory, index}
              <MiniStoriesContentCard {miniStory} {index} />
            {/each}
          {/if}
        </div>
      </div>
    </section>
  </TrackingContext>
</div>
